<template>
  <div class="d-flex flex-row justify-content-between">
    <b-form-group label="From" class="mr-4 ml-4">
      <b-form-input
        v-model="fromValue"
        type="number"
        min="0"
        ></b-form-input>
    </b-form-group>
    <b-form-group label="To" class="mr-4 ml-4">
      <b-form-input
        v-model="toValue"
        type="number"
        min="0"
        ></b-form-input>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "NumberRangeFilter",
  props: ["label", "value"],
  computed: {
    fromValue: {
      get() {
        return this.value.from;
      },
      set(value) {
        this.$emit("input", {
          ...this.value,
          from: value
        });
      }
    },
    toValue: {
      get() {
        return this.value.to;
      },
      set(value) {
        this.$emit("input", {
          ...this.value,
          to: value
        });
      }
    }
  },
}
</script>

<style></style>